module.exports = __webpack_public_path__ + "img/brand-18.d9362fab.png";